import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

const slidersImages = document.querySelectorAll(".images-slider");
const slidersTextMedia = document.querySelectorAll(".text-media-slider");
const slidersLocations = document.querySelectorAll(".locations-slider");
const slidersActiviteiten = document.querySelectorAll(".activiteiten-slider");
const slidersTestimonials = document.querySelectorAll(".testimonials-slider");
const slidersHistoriek = document.querySelectorAll(".historiek-slider");

document.addEventListener("DOMContentLoaded", () => {
    if (slidersImages) {
        slidersImages.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    720: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                },
            });
        });
    }

    if (slidersTextMedia) {
        slidersTextMedia.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    720: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                },
            });
        });
    }

    if (slidersLocations) {
        slidersLocations.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation =
                nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;

            new Swiper(swiperEL, {
                modules: [Navigation],
                // Vaste slide-breedtes (via CSS op .swiper-slide) zodat de cards niet
                // meeschalen met de container en netjes uit het scherm bleeden.
                slidesPerView: "auto",
                spaceBetween: 24,
                speed: 400,
                watchOverflow: true,
                navigation,
            });
        });
    }

    if (slidersActiviteiten) {
        slidersActiviteiten.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation =
                nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;

            new Swiper(swiperEL, {
                modules: [Navigation],
                // Vaste slide-breedtes (via CSS op .swiper-slide) zodat de kaarten netjes
                // uit het scherm bleeden, net als de locations-slider.
                slidesPerView: "auto",
                spaceBetween: 24,
                speed: 400,
                watchOverflow: true,
                navigation,
            });
        });
    }

    if (slidersTestimonials) {
        slidersTestimonials.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation =
                nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;

            new Swiper(swiperEL, {
                modules: [Navigation, EffectFade],
                slidesPerView: 1,
                speed: 400,
                watchOverflow: true,
                loop: true,
                autoHeight: true,
                effect: "fade",
                fadeEffect: { crossFade: true },
                navigation,
            });
        });
    }

    if (slidersHistoriek) {
        slidersHistoriek.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;

            new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 32,
                speed: 400,
                watchOverflow: true,
                autoHeight: true,
                navigation,
                pagination,
            });
        });
    }
});
